import { render, staticRenderFns } from "./ItemCheckout.vue?vue&type=template&id=3e01d67f"
import script from "./ItemCheckout.vue?vue&type=script&lang=js"
export * from "./ItemCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports